import { DotsVerticalIcon } from '@radix-ui/react-icons';
import { IconButton } from '@radix-ui/themes';
import { DropdownMenu } from '@/components/shared/dropdown-menu';
import type { DropdownMenuProps } from '@/components/shared/dropdown-menu';
import { TrashCanIcon } from '@/v2/assets/icons/TrashCanIcon';

interface CollectionActionsDropdownProps {
  itemType: 'folder' | 'file';
  onDeleteCollection?: () => void;
  onDeleteSnippet?: () => void;
}

export function CollectionActionsDropdown({
  itemType,
  onDeleteCollection,
  onDeleteSnippet,
}: CollectionActionsDropdownProps) {
  const dropdownMenuItems: DropdownMenuProps['items'] =
    itemType === 'file' ? [
          {
            label: 'Delete Snippet',
            onClick: onDeleteSnippet || (() => {}),
            icon: <TrashCanIcon size={12} />,
          },
        ]: [];


  //deletion of folders is not yet supported by backend
  if(itemType === 'folder') {
      return null
  }

  return (
    <DropdownMenu items={dropdownMenuItems} align="end">
      <DropdownMenu.Trigger>
        <IconButton
          variant="ghost"
          size="1"
          aria-label="Actions"
        >
          <DotsVerticalIcon width={16} height={16} />
        </IconButton>
      </DropdownMenu.Trigger>
    </DropdownMenu>
  );
}
